import { defaultTrackAppearance } from '../../../renderer/src/track-appearance';
import type { StudioDraft } from './studio-draft';

/** Follow the map palette only while the trace still uses its previous default color. */
export function mapTrackDefault(draft: StudioDraft, previousMap: string, nextMap: string, camera = draft.camera): StudioDraft {
  const previous = defaultTrackAppearance(draft.line, camera, previousMap);
  if (draft.trackAppearance.color.toLowerCase() !== previous.color) return draft;
  const next = defaultTrackAppearance(draft.line, camera, nextMap);
  return { ...draft, trackAppearance: { ...draft.trackAppearance, color: next.color } };
}
